export default {
  paperWidthXs: {
    maxWidth: 400,
  },
};
